// Server-side column sort for paginated list pages. Sorting happens on the
// server so it covers every page, not just the rows on screen.
//
// The page binds sortBy / sortDesc to its v-data-table (.sync), adds
// sortParams() to its list request, and has a currentPage watcher that
// reloads the list. sortKey ("field|asc") is what TableSortSelect binds to.
export default {
  data() {
    return {
      // Empty sortBy means the endpoint's default order.
      sortBy: null,
      sortDesc: false,
    };
  },
  computed: {
    sortKey: {
      get() {
        return this.sortBy ? `${this.sortBy}|${this.sortDesc ? "desc" : "asc"}` : "";
      },
      set(value) {
        const [field, order] = (value || "").split("|");
        this.sortBy = field || null;
        this.sortDesc = order === "desc";
      },
    },
  },
  watch: {
    // A header click can change both halves; this reloads once.
    sortKey() {
      if (this.currentPage !== 1) {
        this.currentPage = 1; // the currentPage watcher reloads
      } else {
        this.getList();
      }
    },
  },
  methods: {
    sortParams() {
      return this.sortBy ? { sortBy: this.sortBy, sortOrder: this.sortDesc ? "desc" : "asc" } : {};
    },
  },
};
